import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import BaseReporter from './BaseReporter';
import enviro from 'enviro';
import hubspot from 'hubspot';
import memoizeOne from 'react-utils/memoizeOne';
export var THIRTY_SECONDS = 1000 * 30;

var formatVersion = function formatVersion(version) {
  if (!version) {
    return 'unknown';
  }

  if (version === 'static') {
    return 'dev';
  }

  return version.replace('static-', '');
};

var getMetricsEndpoint = memoizeOne(function () {
  return "https://api.hubspot" + (enviro.getShort() === 'prod' ? '' : 'qa') + ".com/cartographer/v1/in-app?hs_static_app=" + hubspot.bender.currentProject + "&hs_static_app_version=" + formatVersion(hubspot.bender.currentProjectVersion);
});

var InAppReporter = /*#__PURE__*/function (_BaseReporter) {
  _inherits(InAppReporter, _BaseReporter);

  function InAppReporter() {
    var _this;

    _classCallCheck(this, InAppReporter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InAppReporter).call(this));
    _this.resolved = {};
    _this.stopped = false;
    _this.actions = [];
    _this.previousAction = null;
    _this.flushQueueTimeout = undefined;
    _this.currentActionStartTimestamp = null;
    window.addEventListener('unload', function () {
      _this.flushQueue();
    }, false);
    return _this;
  }

  _createClass(InAppReporter, [{
    key: "flushQueue",
    value: function flushQueue() {
      if (!this.actions.length) return;

      try {
        var sent = navigator.sendBeacon(getMetricsEndpoint(), JSON.stringify({
          datapoints: _toConsumableArray(this.actions)
        }));

        if (sent) {
          this.actions = [];
        }
      } catch (e) {// Do nothing
      }
    }
  }, {
    key: "pushAction",
    value: function pushAction(routeInfo, status, duration) {
      if (this.previousAction) {
        this.actions.push({
          from: this.previousAction,
          to: routeInfo,
          duration: duration,
          status: status
        });
      }

      this.previousAction = routeInfo;
    }
  }, {
    key: "report",
    value: function report(action) {
      var _this2 = this;

      if (this.resolved[action.payload.entry.id] || this.stopped) {
        return;
      }

      switch (action.type) {
        case 'ROUTE_TIMEOUT_EXPIRED':
        case 'ROUTE_FAILED':
          {
            var _action$payload = action.payload,
                entry = _action$payload.entry,
                routeSpec = _action$payload.routeSpec;
            var pathname = entry.pathname,
                checks = entry.checks,
                expiredTimestamp = entry.expiredTimestamp;
            var route = routeSpec.route,
                error = routeSpec.error;
            this.pushAction({
              pathname: pathname,
              route: route,
              scenario: action.type === 'ROUTE_FAILED' && error ? error.join(',') : action.type
            }, 'failure', action.type === 'ROUTE_FAILED' ? this.toDuration(checks, this.currentActionStartTimestamp, error) : expiredTimestamp - this.currentActionStartTimestamp);
            break;
          }

        case 'ROUTE_SUCCEEDED':
          {
            var _action$payload2 = action.payload,
                _entry = _action$payload2.entry,
                _routeSpec = _action$payload2.routeSpec,
                extra = _action$payload2.extra;
            var _pathname = _entry.pathname,
                _checks = _entry.checks;
            var _route = _routeSpec.route;
            var scenario = extra.scenario;
            var markers = _routeSpec.success[scenario] || '';
            this.pushAction({
              pathname: _pathname,
              route: _route,
              scenario: scenario || markers.join(',')
            }, 'success', this.toDuration(_checks, this.currentActionStartTimestamp, markers));
            break;
          }

        default:
      }

      switch (action.type) {
        case 'ROUTE_UNEXPECTED':
          {
            this.stopped = true;
            break;
          }

        case 'ROUTE_STARTED':
          {
            var _entry2 = action.payload.entry;
            var timestamp = _entry2.timestamp;
            this.currentActionStartTimestamp = this.currentActionStartTimestamp || timestamp;
            break;
          }

        case 'ROUTE_SUCCEEDED':
        case 'ROUTE_TIMEOUT_EXPIRED':
        case 'ROUTE_FAILED':
          {
            this.currentActionStartTimestamp = null;
            this.resolved[action.payload.entry.id] = true;
            clearTimeout(this.flushQueueTimeout);
            this.flushQueueTimeout = setTimeout(function () {
              _this2.flushQueue();
            }, THIRTY_SECONDS);
            break;
          }

        default:
      }
    }
  }]);

  return InAppReporter;
}(BaseReporter);

export { InAppReporter as default };